import React from 'react'
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import { Theme } from './Theme';
const containerStyle = {
    maxWidth: '800px',
    height: '80vh',
    margin: '0px auto 70px',
    borderRadius: '10px'
};

const center = {
    lat: 50.6218537,
    lng: 26.2454701
};

const defaultOptions = {
    styles: Theme,
}

const MyMap = () => {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: ""
    })
    const mapRef = React.useRef(undefined);


    const onLoad = React.useCallback(function callback(map) {
        mapRef.current = map;
    }, [])

    const onUnmount = React.useCallback(function callback(map) {
        mapRef.current = undefined;
    }, [])

    return isLoaded ? (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={15}
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={defaultOptions}
        >


            <>
                <Marker
                    position={center}
                    icon={{ url: 'https://srv2.imgonline.com.ua/result_img/imgonline-com-ua-Resize-UoteUvMt48Z69.png' }}

                />
            </>
        </GoogleMap>
    ) : <></>
}

export default React.memo(MyMap);